import * as t from 'io-ts';
import { DateFromUnixTime } from 'io-ts-types/lib/DateFromUnixTime';
import { meta } from '../..';

export const recordCodec = t.type({
  '@': DateFromUnixTime,
  t: t.union([t.number, t.null]),
  h: t.union([t.number, t.null]),
});

export const listCodec = t.type({
  data: t.array(recordCodec),
  meta,
});
